module.exports = __webpack_public_path__ + "static/media/jadoo.988b60d0.png";